import { Box, useMediaQuery } from "@mui/material";

import logo from "./../../../assets/logo/logo-2.png";
import { useNavigate } from "react-router-dom";

const LogoComponents = () => {

    const navigate = useNavigate();

    const isMobile = useMediaQuery("(max-width:768px)");
    
    const styleLogoBox: React.CSSProperties = {
        //border: "2px solid #000",
        borderRadius: "1em",
        borderTopLeftRadius: "0",
        borderBottomRightRadius: "0",
        padding: "0.3em 0.5em",
        margin: "0.5em",
        cursor: "pointer"
        //backgroundColor: "#0b9c64"
    }
    const styleImg: React.CSSProperties = {
        width: isMobile ? "100px" : "6em"
    }

    return <Box component='div' style={styleLogoBox} onClick={() => navigate("/")}>
        {/* <Typography variant="h1" style={styleH1}>Maomed</Typography>
        <Typography variant="subtitle2" style={styleS2}>Manaus</Typography> */}
        <img src={logo} alt="Logo" style={styleImg}/>
    </Box>
}
export default LogoComponents;